import { render, staticRenderFns } from "./forex-ea.vue?vue&type=template&id=2a83ba22&scoped=true"
import script from "./forex-ea.vue?vue&type=script&lang=js"
export * from "./forex-ea.vue?vue&type=script&lang=js"
import style0 from "./forex-ea.vue?vue&type=style&index=0&id=2a83ba22&prod&lang=css"
import style1 from "./forex-ea.vue?vue&type=style&index=1&id=2a83ba22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83ba22",
  null
  
)

export default component.exports